module.exports = __webpack_public_path__ + "img/26.a053a161.jpg";